import {call, put, takeLatest, debounce} from "redux-saga/effects";
import {attributeActions} from "./attributeSlice";
import {attributeApi} from "~/api";

function* fetchAttributeList(action) {
	try {
		const response = yield call(attributeApi.gets, action.payload);
		yield put(attributeActions.fetchDataSuccess(response))
	}
	catch (error) {
		console.log('Failed to fetch attribute list', error);
		yield put(attributeActions.fetchDataFailed(error.message));
	}
}

function* handleSearchDebounce(action) {
	yield put(attributeActions.setFilter(action.payload));
}

export default function* attributeSaga() {
	yield takeLatest(attributeActions.fetchData.type, fetchAttributeList);
	yield debounce(500, attributeActions.setFilterWithDebounce.type, handleSearchDebounce)
}
